import { PlatformAdminModel } from '@/models/PlatformAdminModel'
import { ref } from 'vue'

export const platformAdmin = ref<Partial<PlatformAdminModel>>({})
